import { DiscoverOfferingType, DiscoverPrefix } from './App.types'

export enum Routes {
  DISCOVER_CITY = '/b',
  APP_DISCOVER_SPORT_CITY = '/a/l',
  HOME = '/',
  ACTIVITY_DETAILS = '/activity',
}

export enum VenueProfileTabsPrefix {
  OVERVIEW = '/s',
  SPORTS_FIELDS = '/sb',
}

export const CLASSNAME_CONTAINED_CONTENT = 'w-full max-w-6xl my-0 mx-auto'

export const THRESHOLD_TO_SHOW_VENUE_COUNT = 3

export const DISCOVER_OFFERING_PROPERTIES_MAPPING: {
  [key in DiscoverOfferingType]: {
    linkPrefix: DiscoverPrefix
    nameForTracking: string
    translationKey:
      | 'camps'
      | 'classes-and-trainings'
      | 'courses'
      | 'education'
      | 'events'
      | 'livestreams'
      | 'trainings'
      | 'public-matches'
      | 'retreats'
      | 'open-trainings'
      | 'videos'
      | 'workshops'
  }
} = {
  [DiscoverOfferingType.DISCOVER_OFFERING_CAMP_ACTIVITY]: {
    linkPrefix: DiscoverPrefix.CAMPS,
    translationKey: 'camps',
    nameForTracking: 'camps',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_CLASS_ACTIVITY]: {
    linkPrefix: DiscoverPrefix.CLASSES,
    translationKey: 'classes-and-trainings',
    nameForTracking: 'classes and trainings',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_COURSE_ACTIVITY]: {
    linkPrefix: DiscoverPrefix.COURSES,
    translationKey: 'courses',
    nameForTracking: 'courses',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_EDUCATION_ACTIVITY]: {
    linkPrefix: DiscoverPrefix.EDUCATION,
    translationKey: 'education',
    nameForTracking: 'education',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_EVENT_ACTIVITY]: {
    linkPrefix: DiscoverPrefix.EVENTS,
    translationKey: 'events',
    nameForTracking: 'events',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_LIVESTREAM]: {
    linkPrefix: DiscoverPrefix.LIVESTREAMS,
    translationKey: 'livestreams',
    nameForTracking: 'livestreams',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_OPENTRAINING_ACTIVITY]: {
    linkPrefix: DiscoverPrefix.OPEN_TRAININGS,
    translationKey: 'open-trainings',
    nameForTracking: 'open trainings',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_PUBLIC_MATCH]: {
    linkPrefix: DiscoverPrefix.PUBLIC_MATCHES,
    translationKey: 'public-matches',
    nameForTracking: 'public matches',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_RETREAT_ACTIVITY]: {
    linkPrefix: DiscoverPrefix.RETREATS,
    translationKey: 'retreats',
    nameForTracking: 'retreats',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_TRAINING_ACTIVITY]: {
    linkPrefix: DiscoverPrefix.TRAININGS,
    translationKey: 'trainings',
    nameForTracking: 'trainings',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_VIDEO]: {
    linkPrefix: DiscoverPrefix.VIDEOS,
    translationKey: 'videos',
    nameForTracking: 'videos',
  },
  [DiscoverOfferingType.DISCOVER_OFFERING_WORKSHOP_ACTIVITY]: {
    linkPrefix: DiscoverPrefix.WORKSHOPS,
    translationKey: 'workshops',
    nameForTracking: 'workshops',
  },
}

export const DISCOVER_TAB_MAPPING_FOR_AMPLITUDE: {
  [key in DiscoverOfferingType]: string
} = {
  [DiscoverOfferingType.DISCOVER_OFFERING_CAMP_ACTIVITY]: 'camps',
  [DiscoverOfferingType.DISCOVER_OFFERING_CLASS_ACTIVITY]: 'classes and trainings',
  [DiscoverOfferingType.DISCOVER_OFFERING_COURSE_ACTIVITY]: 'courses',
  [DiscoverOfferingType.DISCOVER_OFFERING_EDUCATION_ACTIVITY]: 'education',
  [DiscoverOfferingType.DISCOVER_OFFERING_EVENT_ACTIVITY]: 'events',
  [DiscoverOfferingType.DISCOVER_OFFERING_LIVESTREAM]: 'livestreams',
  [DiscoverOfferingType.DISCOVER_OFFERING_OPENTRAINING_ACTIVITY]: 'open trainings',
  [DiscoverOfferingType.DISCOVER_OFFERING_PUBLIC_MATCH]: 'public matches',
  [DiscoverOfferingType.DISCOVER_OFFERING_RETREAT_ACTIVITY]: 'retreats',
  [DiscoverOfferingType.DISCOVER_OFFERING_TRAINING_ACTIVITY]: 'trainings',
  [DiscoverOfferingType.DISCOVER_OFFERING_VIDEO]: 'videos',
  [DiscoverOfferingType.DISCOVER_OFFERING_WORKSHOP_ACTIVITY]: 'workshops',
}
